var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 0.833984H4.16667C3.062 0.835308 2.00296 1.27472 1.22185 2.05583C0.440735 2.83695 0.00132321 3.89599 0 5.00065L0 15.0007C0.00132321 16.1053 0.440735 17.1644 1.22185 17.9455C2.00296 18.7266 3.062 19.166 4.16667 19.1673H15.8333C16.938 19.166 17.997 18.7266 18.7782 17.9455C19.5593 17.1644 19.9987 16.1053 20 15.0007V5.00065C19.9987 3.89599 19.5593 2.83695 18.7782 2.05583C17.997 1.27472 16.938 0.835308 15.8333 0.833984ZM4.16667 2.50065H15.8333C16.3323 2.50163 16.8196 2.65191 17.2325 2.93215C17.6453 3.2124 17.9649 3.60977 18.15 4.07315L11.7683 10.4557C11.2987 10.9234 10.6628 11.186 10 11.186C9.33715 11.186 8.70131 10.9234 8.23167 10.4557L1.85 4.07315C2.03512 3.60977 2.35468 3.2124 2.76754 2.93215C3.1804 2.65191 3.66768 2.50163 4.16667 2.50065ZM15.8333 17.5007H4.16667C3.50363 17.5007 2.86774 17.2373 2.3989 16.7684C1.93006 16.2996 1.66667 15.6637 1.66667 15.0007V6.25065L7.05333 11.634C7.83552 12.4142 8.89521 12.8524 10 12.8524C11.1048 12.8524 12.1645 12.4142 12.9467 11.634L18.3333 6.25065V15.0007C18.3333 15.6637 18.0699 16.2996 17.6011 16.7684C17.1323 17.2373 16.4964 17.5007 15.8333 17.5007Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.13b41c92db38e0909c8d560195ba66ce.svg";
export { ForwardRef as ReactComponent };